// extracted by mini-css-extract-plugin
export default {"container":"device-registration-page_container__qmDCq","statusIcon":"device-registration-page_statusIcon__6Zx6Z"};